// on hover open megamenu

   function bindMouseOverToMegaMenu (item) {
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
          item.setAttribute("open", true);
        });
        item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  }
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details.mega-menu");
  items.forEach(bindMouseOverToMegaMenu);


// product Card quantity

function updateQuantity(element, change) {
  var quantityInput = element.parentNode.querySelector('input[name="quantity"]');
  var currentValue = parseInt(quantityInput.value);
  var newValue = currentValue + change;
  if (newValue >= 1) {
      quantityInput.value = newValue;
  }
}